import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'app-btn-cell-renderer-remove',
  templateUrl: './btn-cell-renderer-remove.component.html',
  styleUrls: ['./btn-cell-renderer-remove.component.css']
})
export class BtnCellRendererRemoveComponent implements ICellRendererAngularComp, OnDestroy {

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  params;
  // label: string;

  agInit(params): void {
    this.params = params;
    // this.label = this.params.label || null;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.onClick(params);

    }
  }

  // private params: any;

  // agInit(params: any): void {
  //   this.params = params;
  // }

  // btnClickedHandler() {
  //   this.params.clicked(this.params.value);
  // }

  ngOnDestroy() {
    // no need to remove the button click handler 
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }

}
